import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import ModalHeader from '@common-components/headers/ModalHeader';

const QHPIneligibleModal = props => {
    const {
        modalHeaderProps,
        actions: {
            hideModal
        }
    } = props;

    const handleCloseModal = () => hideModal();

    return (
        <Fragment>
            <ModalHeader {...modalHeaderProps } />
            <div className="grid-container">
                <div className="gi-modal__body">
                    <p>
                        <FormattedMessage id="further_action.modal.QHP_ineligible_msg"/>
                    </p>
                </div>
            </div>
            <div className="gi-modal__controls">
                <button className="usa-button usa-button--outline gi-button gi-button__outline" onClick={handleCloseModal}>
                    <FormattedMessage id="dashboard.ok"/>
                </button>
            </div>
        </Fragment>
    );
};

export default QHPIneligibleModal;
